import React from 'react';

interface IProps {
  width?: string;
  height?: string;
  background?: string;
  color?: string;
}

const ClockIcon = ({
  width = '16',
  height = '17',
  background = 'none',
  color = '#757575',
}: IProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 17"
      fill={background}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00264 1.09521C3.96002 1.09521 0.664062 4.38651 0.664062 8.42846C0.664062 12.4704 3.96069 15.7657 8.00264 15.7657C12.0446 15.7657 15.3345 12.4704 15.3345 8.42846C15.3345 4.38651 12.0446 1.09521 8.00264 1.09521ZM8.00264 2.42853C8.79086 2.42721 9.5716 2.58152 10.3001 2.88259C11.0285 3.18367 11.6904 3.62559 12.2477 4.18301C12.805 4.74044 13.2468 5.4024 13.5477 6.13093C13.8486 6.85946 14.0027 7.64023 14.0012 8.42846C14.0028 9.2169 13.8488 9.9979 13.5479 10.7267C13.2471 11.4555 12.8054 12.1177 12.2481 12.6755C11.6909 13.2333 11.029 13.6756 10.3005 13.977C9.57194 14.2785 8.79108 14.4333 8.00264 14.4324C7.21386 14.4333 6.43263 14.2787 5.70369 13.9774C4.97475 13.676 4.31241 13.2338 3.7546 12.6761C3.19678 12.1184 2.75445 11.4562 2.45292 10.7273C2.15139 9.99843 1.99659 9.21724 1.99738 8.42846C1.99738 5.10716 4.68134 2.42853 8.00264 2.42853ZM7.99197 3.75251C7.90385 3.75338 7.81678 3.7717 7.73579 3.80643C7.6548 3.84116 7.5815 3.8916 7.52012 3.95483C7.45875 4.01806 7.41052 4.09284 7.37822 4.17483C7.34593 4.25682 7.33021 4.3444 7.33198 4.43251V8.42846C7.33235 8.51618 7.35003 8.60297 7.384 8.68385C7.41798 8.76473 7.46758 8.83811 7.52998 8.89978L10.1966 11.5677C10.2583 11.6312 10.332 11.6818 10.4134 11.7165C10.4949 11.7512 10.5824 11.7693 10.6709 11.7698C10.7594 11.7703 10.8471 11.7532 10.9289 11.7194C11.0108 11.6857 11.085 11.636 11.1474 11.5732C11.2098 11.5104 11.2591 11.4359 11.2924 11.3539C11.3257 11.2719 11.3423 11.1841 11.3413 11.0955C11.3403 11.007 11.3217 10.9196 11.2865 10.8384C11.2514 10.7572 11.2004 10.6838 11.1366 10.6224L8.66663 8.15246V4.43251C8.66842 4.34317 8.65224 4.25438 8.61903 4.17142C8.58583 4.08846 8.53629 4.01302 8.47336 3.94958C8.41042 3.88615 8.33537 3.83602 8.25268 3.80216C8.16998 3.76831 8.08132 3.75142 7.99197 3.75251Z"
        fill={color}
      />
    </svg>
  );
};

export default ClockIcon;
